module.exports = __webpack_public_path__ + "img/jl.960199dc.png";